<template>
  <sdPageHeader :title="$t('pages.banners.detail.title')" />
  <Main>
    <sdCards>

      <a-form layout="vertical" :model="bannerDetail" @submit="handleFinishForm">
        <a-form-item :label="$t('pages.banners.detail.label-title')">
          <a-input v-model:value="bannerDetail.title" :placeholder="$t('pages.banners.detail.placeholder-title')" required />
        </a-form-item>

        <a-form-item :label="$t('pages.banners.detail.label-url')">
          <a-input v-model:value="bannerDetail.url" :placeholder="$t('pages.banners.detail.placeholder-url')" required />
        </a-form-item>

        <a-form-item :label="$t('pages.banners.detail.label-rank')">
          <a-input v-model:value="bannerDetail.rank" type="number" :placeholder="$t('pages.banners.detail.placeholder-rank')" required />
        </a-form-item>

        <a-form-item :label="$t('pages.banners.detail.label-state')">
          <a-space align="baseline">
            <a-switch v-model:checked="bannerDetail.active" />
            <p>{{ bannerDetail.active ? $t('common.1') : $t('common.0') }}</p>
          </a-space>
        </a-form-item>

        <a-form-item :label="$t('pages.banners.detail.label-isStatic')">
          <a-checkbox v-model:checked="bannerDetail.favourite">{{ $t('pages.banners.detail.static') }}</a-checkbox>
        </a-form-item>

        <a-row type="flex" justify="space-between">
          <a-col :span="6">
            <a-form-item :label="$t('pages.banners.detail.label-change-image')">
              <div class="clearfix">
                <a-upload :file-list="fileList" :remove="handleRemove" :before-upload="saveFile" required>
                  <a-button>
                    <upload-outlined></upload-outlined>
                    {{ $t('pages.banners.detail.choose-picture') }}
                  </a-button>
                </a-upload>
              </div>
            </a-form-item>
          </a-col>
          <a-col :offset="8" :span="10">
            <img v-if="hasFile" :src="image" height="100" style="max-width: 500px" />
          </a-col>
        </a-row>

        <sdButton :disabled="!hasFile"  size="default" htmlType="submit" type="primary">{{ $t('common.save') }} </sdButton>
      </a-form>
    </sdCards>
  </Main>
</template>

<script>
import { Main } from '@/view/styled';
import { UploadOutlined } from '@ant-design/icons-vue';
import { useRouter } from 'vue-router';

export default {
  name: 'BannerDetail',
  components: {
    Main,
    UploadOutlined,
  },
  data() {
    return {
      detail_id: this.$route.params.id,
      bannerDetail: {},
      hasFile: true,
      image: null,
      router: useRouter(),
      fileList: [],
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.$appAxios.post(this.$endpoints.banners_detail, { id: this.detail_id }).then(response => {
        if (response.data.status === true) {
          this.bannerDetail = response.data.data;
          this.bannerDetail.active = this.bannerDetail.active ? true : false;
          this.bannerDetail.favourite = this.bannerDetail.favourite ? true : false;
          this.image = this.bannerDetail.image;
        } else {
          this.$message.error(this.$t('common.error-message'));
        }
      });
    },
    handleFinishForm() {
        this.updateBanner();
    },
    updateBanner() {
      const formData = new FormData();

      this.fileList.forEach(file => {
        formData.append('file', file);
      });

      this.bannerDetail.favourite = this.bannerDetail.favourite ? 1 : 0;
      this.bannerDetail.active = this.bannerDetail.active ? 1 : 0;

      for (var key in this.bannerDetail) {
        formData.append(key, this.bannerDetail[key]);
      }

      this.$appAxios.post(this.$endpoints.banners_update_record, formData).then(response => {
        if (response.data.status === true) {
          this.$message.success(this.$t('common.success-message'));
          this.router.push('/banners');
        } else {
          this.$message.error(this.$t('common.error-message'));
        }
      });
    },
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/svg+xml';
      if (!isJpgOrPng) {
        this.$message.error(this.$t('pages.apps.images.error-type'));
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error(this.$t('pages.apps.images.error-size'));
      }
      return isJpgOrPng && isLt2M;
    },
    saveFile(file) {
      if (!this.beforeUpload(file)) {
        return false;
      }
      if (this.fileList.length === 0) {
        this.fileList.push(file);
        this.readFile();
        this.file = file;
      } else {
        this.$message.error(this.$t('pages.banners.error-only-one-image'));
      }
      return false;
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      this.fileList.splice(index, 1);
      this.hasFile = false;
    },
    readFile() {
      var example = this.fileList[0];
      if (example.name.includes('.png') || example.name.includes('.jpg')) {
        this.hasFile = true;
        this.image = URL.createObjectURL(example);
      } else {
        this.hasFile = false;
      }
    },
  },
};
</script>
